import { createSlice } from "@reduxjs/toolkit";
import { BrandDataSlice } from "types/brand";
import { fetchBrandData } from "./thunk";

const initialState: BrandDataSlice = {
    brands: {},
    error: null,
    loading: false
}

const brandDataSlice = createSlice({
    name: 'brandData',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchBrandData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchBrandData.fulfilled, (state, action) => {
            state.brands[action.payload.id] = {
                brand: action.payload,
                last_fetched_at: Date.now()
            }
            state.loading = false;
            state.error = null;
        })
        .addCase(fetchBrandData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'Failed to fetch brand data';
        })
    }
})

export default brandDataSlice.reducer;